/**
 * Data test IDs for chatbot components
 * Centralized constants for consistent testing across the chatbot module
 */

export const CHATBOT_TEST_IDS = {
  // Main container
  CONTAINER: 'chatbot-container',
  CHAT_AREA: 'chatbot-chat-area',
  MESSAGES_CONTAINER: 'chatbot-messages-container',
  HEADER: 'chatbot-header',
  HEADER_CONTENT: 'chatbot-header-content',
  DRAG_HANDLE: 'chatbot-drag-handle',
  AI_ICON: 'chatbot-ai-icon',
  TITLE: 'chatbot-title',
  CONTROLS: 'chatbot-controls',

  // Input area
  INPUT_CONTAINER: 'chatbot-input-container',
  INPUT_FIELD: 'chatbot-input-field',
  SEND_BUTTON: 'chatbot-send-button',
  SEND_BUTTON_ICON: 'chatbot-send-button-icon',

  // Bot message components
  BOT_MESSAGE: 'chatbot-bot-message',
  BOT_MESSAGE_LAYOUT: 'chatbot-bot-message-layout',
  BOT_MESSAGE_ICON: 'chatbot-bot-message-icon',
  BOT_MESSAGE_BUBBLE: 'chatbot-bot-message-bubble',
  BOT_MESSAGE_CONTENT: 'chatbot-bot-message-content',
  BOT_MESSAGE_PENDING: 'chatbot-bot-message-pending',
  BOT_MESSAGE_TYPEWRITER: 'chatbot-bot-message-typewriter',
  BOT_MESSAGE_MARKDOWN: 'chatbot-bot-message-markdown',
  BOT_MESSAGE_FOOTER: 'chatbot-bot-message-footer',
  BOT_MESSAGE_SOURCES: 'chatbot-bot-message-sources',

  // User message components
  USER_MESSAGE: 'chatbot-user-message',
  USER_MESSAGE_LAYOUT: 'chatbot-user-message-layout',
  USER_MESSAGE_CONTENT: 'chatbot-user-message-content',

  // UI states
  LOADING_INDICATOR: 'chatbot-loading-indicator',
  ERROR_MESSAGE: 'chatbot-error-message',
  ERROR_RETRY_BUTTON: 'chatbot-error-retry-button',
  ERROR_DISMISS_BUTTON: 'chatbot-error-dismiss-button',
  TYPING_INDICATOR: 'chatbot-typing-indicator',

  // Additional components
  SCROLL_INDICATOR: 'chatbot-scroll-indicator',
  WELCOME_MESSAGE: 'chatbot-welcome-message',
} as const;

// Type for test ID values
export type ChatbotTestId =
  typeof CHATBOT_TEST_IDS[keyof typeof CHATBOT_TEST_IDS];
